import * as types from '../mutations'
import { APP } from '../../constants'

const state = {
  auctions: [],
  lots: [],
  lots_unsold: [],
  lots_sold: [],
  lots_initial: [],
  show: APP.LOTS_PER_PAGE.DEFAULT,
  order: APP.LOT_ORDER.LOT_NUMBER,
  results_order: APP.RESULTS_LOT_ORDER.LOT_NUMBER
}

const mutations = {
  [types.AUCTION_SET_AUCTIONS]: (state, auctions) => {
    if(auctions){
    state.auctions = auctions.data;
    }else{
      state.auctions = null;
    }
  },
  [types.AUCTION_SET_LOTS]: (state, lots) => {
    state.lots = lots;
    state.lots_initial = lots;
    state.lots_sold = lots.filter(function (item) {
      return item.auction_status == 1;
    });
    state.lots_unsold = lots.filter(function (item) {
      return item.auction_status == null || item.auction_status == 0 || item.auction_status == 2;
    });
  },
  [types.AUCTION_SET_SHOW]: (state, show) => {
    state.show = show;
  },
  [types.AUCTION_SET_ORDER]: (state, order) => {
    state.order = order;
    switch (order) {
      case APP.LOT_ORDER.LOT_NUMBER:
        state.lots.sort(window.compareValues('number', 'asc'));
        break;
      case APP.LOT_ORDER.LOT_PRICE_ASC:
        state.lots.sort(window.compareValues('sorting_price', 'asc'));
        break;
      case APP.LOT_ORDER.LOT_PRICE_DESC:
        state.lots.sort(window.compareValues('sorting_price', 'desc'));
        break;
      default:
        state.lots.sort(window.compareValues('number', 'asc'));
        break;
    }
  },
  [types.AUCTION_RESULTS_SET_ORDER]: (state, results_order) => {
    state.results_order = results_order;
    switch (results_order) {
      case APP.RESULTS_LOT_ORDER.LOT_NUMBER:
        state.lots = state.lots_initial.sort(window.compareValues('number', 'asc'));
        break;
      case APP.RESULTS_LOT_ORDER.LOT_PRICE_ASC:
        state.lots = state.lots_initial.sort(window.compareValues('sorting_price', 'asc'));
        break;
      case APP.RESULTS_LOT_ORDER.LOT_PRICE_DESC:
        state.lots = state.lots_initial.sort(window.compareValues('sorting_price', 'desc'));
        break;
      case APP.RESULTS_LOT_ORDER.LOT_SOLD:
        state.lots = state.lots_sold;
        break;
      case APP.RESULTS_LOT_ORDER.LOT_UNSOLD:
        state.lots = state.lots_unsold;
        break;
      default:
        state.lots.sort(window.compareValues('number', 'asc'));
        break;
    }
  },
  [types.AUCTION_INIT]: (state, payload) => {
    if (localStorage.getItem('order')) {
      var order = localStorage.getItem('order');
      state.order = order;
    } else {
      state.order = APP.LOT_ORDER.LOT_NUMBER;
    }
    if (localStorage.getItem('show')) {
      var show = localStorage.getItem('show');
      state.show = show;
    } else {
      state.show = APP.LOTS_PER_PAGE.DEFAULT
    }
  }
}

const getters = {
  auctions: (state) => state.auctions,
  lots: (state) => state.lots,
  initialLots: (state) => state.lots_initial,
  show: (state) => Number(state.show),
  order: (state) => state.order,
  results_order: (state) => state.results_order
}

export default {
  state,
  mutations,
  getters
}